






















































































































































































































































































































































































































































































































































































































































import { Component, Watch, Vue } from 'vue-property-decorator'
/* component */
import CommonHeader from '@/app/components/Common/Header.vue'
import Loading from '@/app/components/Common/Loading.vue'
import ErrorModal from '@/app/components/Common/ErrorModal.vue'
import CamImgSearch from '@/app/components/CamImage/CamImageSearch.vue'
import CamImgModalSearch from '@/app/components/CamImage/CamImageModalSearch.vue'
import ImageModal from '@/app/components/Common/ImageModal.vue'
import NoticeModal from '@/app/components/Common/NoticeModal.vue'
import CamFieldImg from '@/app/components/CamImage/CamFieldImg.vue'
/* api */
import GetImageApi from '@/app/model/api/getImageApi'
import CamImageApi from '@/app/model/api/camImageApi'
import GetCamImgApi from '@/app/model/api/getCamImgApi'
/* module */
import Session from '@/app/module/session'
import DateClass from '@/app/module/date'
import CommonClass from '@/app/module/common'
import { routerPath, userType, errorFlag } from '@/app/model/store/domain/const'

@Component({
  components: {
    CommonHeader,
    Loading,
    ErrorModal,
    CamImgSearch,
    CamImgModalSearch,
    ImageModal,
    NoticeModal,
    CamFieldImg
  }
})
export default class CamImage extends Vue {
  /* データ */
  private isSelectingNum: number|null = null
  private selectedImg1Data: any|null = null
  private selectedImg2Data: any|null = null
  private selectedModalImg1Data: any|null = null
  private selectedModalImg2Data: any|null = null
  private groupImgData: any = []
  private noticeMessage: string = '<p>比較確認するには、比較1・比較2の両方を選択してください。</p>'
  private imgData: any = {}
  private imageSize: number = 0
  private grouping: number = this.$store.state.camImageState.grouping
  private image: string = ''
  private comparisonImg1: string = ''
  private comparisonImg2: string = ''
  private modalImgPath: string = require('@/assets/img/no_image.svg')
  private observer: any = null
  private fieldBoxHeight: string = 'auto'
  // 表示切替
  private isSelectingMode: boolean = false
  private showImgModal: boolean = false
  private showImgComparisonModal: boolean = false
  private showLoading: boolean = false
  private showNoticeModal: boolean = false
  private notDataMessage: boolean = false
  private showComparisonImg1Loading: boolean = false
  private showComparisonImg2Loading: boolean = false
  private isFirstScroll: boolean = true

  private get imgSize (): number {
    return this.$store.state.fieldChoiceState.modalId
  }

  created () {
    if (this.$store.state.camImageState.recordDate === '') {
      const date = new Date()
      date.setDate(date.getDate() - 1)
      this.$store.commit('camImageState/setRecordDate', date)
    }

    this.getCamImageData()
    this.changeImgSize()
  }

  mounted () {
    const images2: any = document.getElementById('images2')!
    if (images2 !== null) {
      images2.addEventListener('scroll', () => {
        if (this.isFirstScroll && this.grouping === 1) {
          this.isFirstScroll = false
          let el: any = document.getElementsByClassName('field-box')
          this.fieldBoxHeight = el[0].clientHeight + 'px'
        }
      })
    }
  }

  private judgeHoverClass (data: any, fieldId: number) {
    if (!this.isSelectingMode) {
      return false
    }

    if (this.isSelectingNum === 1) {
      if (this.selectedImg2Data !== null && fieldId === this.selectedImg2Data.field_id && data.display_number === this.selectedImg2Data.display_number) {
        return false
      } else {
        return true
      }
    } else {
      if (this.selectedImg1Data !== null && fieldId === this.selectedImg1Data.field_id && data.display_number === this.selectedImg1Data.display_number) {
        return false
      } else {
        return true
      }
    }
  }

  private judgeSelectedClass (selectNum: number, data: any, fieldId: number) {
    if (selectNum === 1) {
      if (this.selectedImg1Data !== null && fieldId === this.selectedImg1Data.field_id && data.display_number === this.selectedImg1Data.display_number) {
        return true
      }
    } else if (selectNum === 2) {
      if (this.selectedImg2Data !== null && fieldId === this.selectedImg2Data.field_id && data.display_number === this.selectedImg2Data.display_number) {
        return true
      }
    } else {
      if ((this.selectedImg1Data !== null && fieldId === this.selectedImg1Data.field_id && data.display_number === this.selectedImg1Data.display_number) ||
          (this.selectedImg2Data !== null && fieldId === this.selectedImg2Data.field_id && data.display_number === this.selectedImg2Data.display_number)) {
        return true
      }
    }
    return false
  }

  private changeImgSize () {
    if (this.grouping === 0) {
      if (this.$store.state.camImageState.imgSize === '1') {
        this.imageSize = 20
      } else if (this.$store.state.camImageState.imgSize === '2') {
        this.imageSize = 25
      } else if (this.$store.state.camImageState.imgSize === '3') {
        this.imageSize = 33
      } else if (this.$store.state.camImageState.imgSize === '4') {
        this.imageSize = 50
      } else {
        this.imageSize = 100
      }
    } else {
      if (this.$store.state.camImageState.imgSize === '1') {
        this.imageSize = 0.4
      } else if (this.$store.state.camImageState.imgSize === '2') {
        this.imageSize = 0.5
      } else if (this.$store.state.camImageState.imgSize === '3') {
        this.imageSize = 0.66
      } else if (this.$store.state.camImageState.imgSize === '4') {
        this.imageSize = 1
      } else {
        this.imageSize = 2
      }
    }
    this.isFirstScroll = true
  }

  private changeGroup () {
    this.scrollTop()
    this.grouping = this.$store.state.camImageState.grouping
    this.changeImgSize()
  }

  private scrollTop () : any {
    if (this.grouping === 0) {
      const images1: any = document.getElementById('images1')!
      if (images1 !== null) {
        images1.scrollTop = 0
      }
    } else {
      const images2: any = document.getElementById('images2')!
      if (images2 !== null) {
        images2.scrollTop = 0
      }
    }
  }

  private getCamImageData () {
    (async () => {
      if (!this.showLoading) {
        this.scrollTop()
        this.isFirstScroll = true
        this.showLoading = true
        const data = {
          record_date: DateClass.dateToStringYmd(this.$store.state.camImageState.recordDate, '-'),
          has_camera: this.$store.state.camImageState.hasCamera,
          has_planting: this.$store.state.camImageState.hasPlanting
        }

        const result = await CamImageApi.getCamImageData(data)

        if (result.isOk()) {
          this.imgData = result.getPayload().fields
          this.changeRecordDate(this.imgData)
          this.groupBy()

          if (this.imgData.length === 0) {
            this.notDataMessage = true
          } else {
            this.notDataMessage = false
          }
        } else {
          const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
        }
        this.showLoading = false
      }
    })()
  }

  private getCamImage (recordDate: any) {
    (async () => {
      if (!this.showLoading) {
        this.showLoading = true
        const data = {
          record_date: DateClass.dateToStringYmd(recordDate, '-'),
          has_camera: this.$store.state.camImageState.hasCamera,
          has_planting: this.$store.state.camImageState.hasPlanting
        }

        const result = await CamImageApi.getCamImageData(data)

        if (result.isOk()) {
          let imgData = result.getPayload().fields
          this.changeRecordDate(imgData)
        } else {
          const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
        }
        this.showLoading = false
      }
    })()
  }

  private changeRecordDate (imgData: any) {
    // 左圃場の情報取得
    this.comparisonImg1 = require('@/assets/img/no_image.svg')
    if (this.selectedImg1Data !== null) {
      let id = null
      let img1Data = imgData.filter((data: any) => data.field_id === this.selectedImg1Data.field_id)
      let select1Data
      if (img1Data.length === 0) {
        select1Data = null
      } else {
        let img = img1Data[0].images.filter((data: any) => data.display_number === this.selectedImg1Data.display_number)
        if (img.length === 0) {
          select1Data = {
            field_id: this.selectedImg1Data.field_id,
            field_name: this.selectedImg1Data.field_name,
            fieldcam_sensor_record_id: '',
            sensor_point_name: '',
            display_number: this.selectedImg1Data.display_number,
            record_date: ''
          }
        } else {
          select1Data = {
            field_id: this.selectedImg1Data.field_id,
            field_name: this.selectedImg1Data.field_name,
            fieldcam_sensor_record_id: img[0].fieldcam_sensor_record_id,
            sensor_point_name: img[0].sensor_point_name,
            display_number: this.selectedImg1Data.display_number,
            record_date: img[0].record_date
          }
          id = img[0].fieldcam_sensor_record_id
        }
      }
      if (this.showImgComparisonModal) {
        this.selectedModalImg1Data = select1Data
        this.getOriginalImg(id, 1)
      } else {
        this.selectedImg1Data = select1Data
      }
    }

    // 右圃場の情報取得
    this.comparisonImg2 = require('@/assets/img/no_image.svg')
    if (this.selectedImg2Data !== null) {
      let id = null
      let img2Data = imgData.filter((data: any) => data.field_id === this.selectedImg2Data.field_id)
      let select2Data
      if (img2Data.length === 0) {
        select2Data = null
      } else {
        let img = img2Data[0].images.filter((data: any) => data.display_number === this.selectedImg2Data.display_number)
        if (img.length === 0) {
          select2Data = {
            field_id: this.selectedImg2Data.field_id,
            field_name: this.selectedImg2Data.field_name,
            fieldcam_sensor_record_id: '',
            sensor_point_name: '',
            display_number: this.selectedImg2Data.display_number,
            record_date: ''
          }
        } else {
          select2Data = {
            field_id: this.selectedImg2Data.field_id,
            field_name: this.selectedImg2Data.field_name,
            fieldcam_sensor_record_id: img[0].fieldcam_sensor_record_id,
            sensor_point_name: img[0].sensor_point_name,
            display_number: this.selectedImg2Data.display_number,
            record_date: img[0].record_date
          }
          id = img[0].fieldcam_sensor_record_id
        }
      }
      if (this.showImgComparisonModal) {
        this.selectedModalImg2Data = select2Data
        this.getOriginalImg(id, 2)
      } else {
        this.selectedImg2Data = select2Data
      }
    }
  }

  private async getOriginalImg (id: number, num: number) {
    if (num === 1) {
      // 比較１
      if (id === null) {
        this.comparisonImg1 = require('@/assets/img/no_image.svg')
      } else {
        this.showComparisonImg1Loading = true
        this.comparisonImg1 = require('@/assets/img/no_image.svg')

        const result = await GetCamImgApi.getCamImgData(id, '')
        if (typeof result !== 'object') {
          this.comparisonImg1 = String(result)
        }
        this.showComparisonImg1Loading = false
      }
    } else if (num === 2) {
      // 比較２
      if (id === null) {
        this.comparisonImg2 = require('@/assets/img/no_image.svg')
      } else {
        this.showComparisonImg2Loading = true
        this.comparisonImg2 = require('@/assets/img/no_image.svg')

        const result = await GetCamImgApi.getCamImgData(id, '')
        if (typeof result !== 'object') {
          this.comparisonImg2 = String(result)
        }
        this.showComparisonImg2Loading = false
      }
    } else {
      // 拡大モーダル
      this.modalImgPath = require('@/assets/img/no_image.svg')
      const result = await GetCamImgApi.getCamImgData(id, '')
      if (typeof result !== 'object') {
        this.modalImgPath = String(result)
      }
      this.showLoading = false
      this.showImgModal = true
    }
  }

  private groupBy () {
    // 地区
    const accordionList = this.imgData.reduce(function (rv: any, x: any) {
      (rv[x.district.district_id] = rv[x.district.district_id] || []).push(x)
      return rv
    }, {})
    // 一番多い圃場数を判定
    let fieldLengthArray = []
    for (let i in accordionList) {
      fieldLengthArray.push(accordionList[i].length)
    }
    let max = Math.max(...fieldLengthArray)

    let list = []
    for (let k in accordionList) {
      // 一番多い圃場数に合わせる
      for (let i = accordionList[k].length; i < max; i++) {
        accordionList[k].push({
          field_name: ''
        })
      }
      // 表示用の配列作成
      list.push({
        district_name: accordionList[k][0].district.district_name,
        sort_number: accordionList[k][0].district.sort_number,
        fields: accordionList[k]
      })
    }
    list.sort(function (a: any, b: any) {
      // 並び順の昇順
      if (a.sort_number < b.sort_number) {
        return -1
      }
      if (a.sort_number > b.sort_number) {
        return 1
      }
      // 地区名の昇順
      if (a.district_name < b.district_name) {
        return -1
      }
      if (a.district_name > b.district_name) {
        return 1
      }
      return 0
    })
    this.groupImgData = list
  }

  // 比較選択モード
  private doSelectMode (num: number) {
    this.isSelectingNum = num
    this.isSelectingMode = true
    this.showImgComparisonModal = false
  }

  // 比較選択モードキャンセル
  private doSelectCancel () {
    this.isSelectingNum = null
    this.isSelectingMode = false
  }

  private doSelectReset () {
    this.isSelectingMode = false
    this.showImgComparisonModal = false
    this.selectedImg1Data = null
    this.selectedImg2Data = null
  }

  private doImgComparison () {
    if (this.selectedImg1Data === null || this.selectedImg2Data === null) {
      this.showNoticeModal = true
      return
    }
    this.showImgComparisonModal = !this.showImgComparisonModal
    if (this.showImgComparisonModal) {
      this.selectedModalImg1Data = this.selectedImg1Data
      this.selectedModalImg2Data = this.selectedImg2Data
      this.getOriginalImg(this.selectedModalImg1Data.fieldcam_sensor_record_id, 1)
      this.getOriginalImg(this.selectedModalImg2Data.fieldcam_sensor_record_id, 2)
    } else {
      this.comparisonImg1 = ''
      this.comparisonImg2 = ''
    }
  }

  private clickFieldImg (data: any, imgData: any) {
    if (this.isSelectingMode) {
      if (this.isSelectingNum === 1) {
        if (this.selectedImg2Data !== null &&
            this.selectedImg2Data.field_id === data.field_id &&
            this.selectedImg2Data.display_number === imgData.display_number) {
          return
        }
      } else {
        if (this.selectedImg1Data !== null &&
            this.selectedImg1Data.field_id === data.field_id &&
            this.selectedImg1Data.display_number === imgData.display_number) {
          return
        }
      }
      // 選択状態にする
      const selectData = {
        field_id: data.field_id,
        field_name: data.field_name,
        fieldcam_sensor_record_id: imgData.fieldcam_sensor_record_id,
        sensor_point_name: imgData.sensor_point_name,
        display_number: imgData.display_number,
        record_date: imgData.record_date
      }

      if (this.isSelectingNum === 1) {
        this.selectedImg1Data = selectData
      } else {
        this.selectedImg2Data = selectData
      }
      this.isSelectingMode = false
      this.isSelectingNum = null
    } else {
      // 画像拡大モーダル表示
      this.getOriginalImg(imgData.fieldcam_sensor_record_id, 0)
      this.showLoading = true
      this.modalImgPath = ''
    }
  }
}
